import { EventDifficultyLevel } from '../../../../../../App.types'

export enum ActivityLocationType {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR',
  ONLINE = 'ONLINE',
}

export enum FILTER_TYPE {
  LOCATION_OFFERING = 'offering',
  LEVEL = 'level',
}

export type FILTER_OPTIONS = ActivityLocationType | EventDifficultyLevel

export enum FILTER_KEY_URL_PARAMS {
  DATE = 'date',
  START_TIME = 'start',
  ACTIVITY_LOCATION = 'offering',
  LEVEL = 'level',
}
